import * as angular from 'angular';
import { BehaviorSubject } from 'rxjs';

export class ModalDialogLinkController {
  modalOpenState$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  onClose!: () => void;
  onConfirm!: () => void;

  handleClick($event: Event): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.modalOpenState$.next(true);
  }

  handleClose(): void {
    this.modalOpenState$.next(false);
    if (this.onClose) {
      this.onClose();
    }
  }

  handleConfirm(): void {
    this.modalOpenState$.next(false);
    if (this.onConfirm) {
      this.onConfirm();
    }
  }
}

export const ModalDialogLinkComponent: angular.IComponentOptions = {
  controller: ModalDialogLinkController,
  controllerAs: 'ctrl',
  transclude: true,
  bindings: {
    buttonCancelClasses: '@',
    buttonConfirmClasses: '@',
    confirmButtonCancel: '@',
    confirmButtonConfirm: '@',
    confirmContent: '<',
    confirmTitle: '<',
    modalTheme: '@',
    modalType: '@',
    onClose: '&?',
    onConfirm: '&?',
    onOpen: '&',
  },
  template: `
    <a class="modal-dialog-link" ng-click="ctrl.handleClick($event)">
      <ng-transclude />
      <modal-dialog
        button-cancel-classes="{{ctrl.buttonCancelClasses}}"
        button-confirm-classes="{{ctrl.buttonConfirmClasses}}"
        confirm-button-cancel="{{ctrl.confirmButtonCancel}}"
        confirm-button-confirm="{{ctrl.confirmButtonConfirm}}"
        content="ctrl.confirmContent"
        modal-type="{{ctrl.modalType}}"
        modal-theme="{{ctrl.modalTheme}}"
        on-close="ctrl.handleClose()"
        on-confirm="ctrl.handleConfirm()"
        on-open="ctrl.onOpen()"
        open="ctrl.modalOpenState$ | async:this"
        title="ctrl.confirmTitle"
      />
    </a>
  `,
};
